import { green } from '@mui/material/colors'
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'

import { EarningStats } from '../../types/interfaces'
import { formatCurrency } from '../utils/number'

export const EarningsChart = ({
  data,
}: {
  data: EarningStats['earnings_last_8_weeks']
}) => (
  <ResponsiveContainer height={360}>
    <BarChart data={data}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="date" interval="preserveStart" />
      <YAxis hide />
      <Tooltip formatter={(value) => formatCurrency(value as number)} />
      <Bar dataKey="earnings" fill={green[400]} />
    </BarChart>
  </ResponsiveContainer>
)
